"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordProcessingMLValue = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var WordProcessingMLValue = (function () {
    function WordProcessingMLValue(openXmlValue, wordMLValue) {
        this.openXmlValue = openXmlValue;
        this.wordMLValue = wordMLValue !== undefined ? wordMLValue : this.convertToWordML(openXmlValue);
    }
    WordProcessingMLValue.prototype.convertToWordML = function (openXmlValue) {
        var count = openXmlValue.length;
        var result = [];
        for (var i = 0; i < count; i++) {
            var currentChar = openXmlValue[i];
            if (string_1.StringUtils.stringInUpperCase(currentChar)) {
                result.push('-');
                result.push(currentChar.toLowerCase());
            }
            else
                result.push(currentChar);
        }
        return result.join('');
    };
    return WordProcessingMLValue;
}());
exports.WordProcessingMLValue = WordProcessingMLValue;
